module.exports = __webpack_public_path__ + "img/checkbox-round-activation.9fb115e9.svg";